import { request as apiRequest } from '@/lib/apiClient'

async function apiFetch<T>(
  method: string,
  path: string,
  body?: unknown,
): Promise<T> {
  const { data, error } = await apiRequest<T>(method, path, body)
  if (error) throw new Error(error.message)
  return data as T
}

export type InviteStatus = 'pending' | 'accepted' | 'revoked' | 'expired'

export interface UserInvite {
  id:                string
  email:             string
  expires_at:        string
  accepted_at:       string | null
  revoked_at:        string | null
  created_at:        string
  invited_by_email:  string | null
  status:            InviteStatus
}

interface CreateInviteResponse {
  id:         string
  email:      string
  expires_at: string
  created_at: string
  email_sent: boolean
}

interface CheckTokenResponse {
  valid: boolean
  email?: string
}

export const invitesApi = {
  list(): Promise<UserInvite[]> {
    return apiFetch<UserInvite[]>('GET', '/api/admin/invites')
  },

  create(email: string): Promise<CreateInviteResponse> {
    return apiFetch<CreateInviteResponse>('POST', '/api/admin/invites', { email })
  },

  revoke(id: string): Promise<{ ok: boolean }> {
    return apiFetch<{ ok: boolean }>('DELETE', `/api/admin/invites/${id}`)
  },

  resend(id: string): Promise<CreateInviteResponse> {
    return apiFetch<CreateInviteResponse>('POST', `/api/admin/invites/${id}/resend`)
  },

  // public, no auth required
  checkToken(token: string): Promise<CheckTokenResponse> {
    return apiFetch<CheckTokenResponse>('GET', `/api/auth/invite/check?token=${encodeURIComponent(token)}`)
  },
}
